import { Alert, Box } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

const MESSAGE_BUBBLE_WIDTH = 'calc(100% - 42px)'

export const StyledAddToBasketAlertContainer = styled(Box)`
  ${s({
    mt: 4,
    maxWidth: MESSAGE_BUBBLE_WIDTH,
  })}
`

export const StyledAddToBasketAlert = styled(Alert)`
  border: 0;
  outline: none;
`
